import {
  DatePicker as CSDDatePicker,
  DatePickerProps,
} from "@cloudscape-design/components-themed";
import { RefAttributes } from "react";
import { formatDateHyphen } from "../../../utils/format";
import { isEmpty } from "lodash";

type IDatePickerProps = Omit<
  DatePickerProps & RefAttributes<DatePickerProps.Ref>,
  | "placeholder"
  | "openCalendarAriaLabel"
  | "todayAriaLabel"
  | "nextMonthAriaLabel"
  | "previousMonthAriaLabel"
>;

/**
 * 日付コンポーネント
 */
export const DatePicker = (props: IDatePickerProps) => {
  const { value, ...otherProps } = props;

  return (
    <CSDDatePicker
      {...otherProps}
      value={isEmpty(value) ? "" : formatDateHyphen(value)}
      openCalendarAriaLabel={(selectedDate) =>
        "Choose certificate expiry date" +
        (selectedDate ? `, selected date is ${selectedDate}` : "")
      }
      placeholder="YYYY/MM/DD"
      todayAriaLabel="Today"
      nextMonthAriaLabel="Next month"
      previousMonthAriaLabel="Previous month"
    />
  );
};
